import { Component } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { NavigationCancel, NavigationEnd, NavigationStart,NavigationError, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'SGDHM';
  displayLoading:boolean = false;
  private minSpinnerMs = 300;
  private spinnerStart = 0;
  private spinnerTimer: any;
  constructor(private primengConfig: PrimeNGConfig, private router: Router){
    this.router.events.subscribe((event : any) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.spinnerStart = Date.now();
          this.displayLoading = true;
          if (this.spinnerTimer) { clearTimeout(this.spinnerTimer); this.spinnerTimer = null; }
          break;
        }
        case event instanceof NavigationCancel:
        case event instanceof NavigationError:
        case event instanceof NavigationEnd: {
          const elapsed = Date.now() - this.spinnerStart;
          const remaining = Math.max(0, this.minSpinnerMs - elapsed);
          if (this.spinnerTimer) { clearTimeout(this.spinnerTimer); }
          this.spinnerTimer = setTimeout(() => {
            this.displayLoading = false;
            this.spinnerTimer = null;
          }, remaining);
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  ngOnInit(){
    //this.primengConfig.ripple = true;
  }
  
}

